import { MobileHistoryDateRowStyled } from "./styled/MobileHistoryDateRowStyled";
import { memo } from "react";

function MobileHistoryDateRow(props) {
    const {item} = props;
    return <MobileHistoryDateRowStyled>
        {item.formattedDate}
    </MobileHistoryDateRowStyled>
}

export default memo(MobileHistoryDateRow);
